import React, { useEffect, useRef, useState, useLayoutEffect } from 'react';
import dayjs from 'dayjs';
import { Link, useLocation } from 'react-router-dom';
import './indi.css';
import axios from 'axios';
import {useQuery, keepPreviousData} from '@tanstack/react-query';

const Prevs=(single)=>{
    const prevk = useRef(1);
  
    useEffect(()=>{
        prevk.current = single;
       
    }, [single]);
    
    return prevk.current;
};

const Activ=({colls, jp})=>{
    
    const [pag, setpag] = useState({});
    const [single, setsingle] = useState(window.history?.states?.page == undefined || window.history?.states?.page == null ? 1 : window.history?.states?.page);
    const [addnum, setaddnum] = useState(1);
    const [arum, setarum] = useState(window.history?.states?.molan == undefined || window.history?.states?.molan == null ? "allaround" : window.history?.states?.molan );
  
    const locap = useLocation();
      
    useLayoutEffect(()=>{
        setarum(window.history?.states?.molan == undefined ? "allaround" : window.history?.states?.molan);
        setsingle(window.history?.states?.page == undefined ? 1 : window.history?.states?.page);
       
    },[jp]);

     useLayoutEffect(()=>{
      
        if(window.history.states == undefined || window.history.states == null){
            if(window.history?.tates){
                setarum(window.history.tates.molan == undefined ? "allaround" : window.history.tates.molan);
                setsingle(window.history.tates.page == undefined ? 1 : window.history.tates.page);
                const nnoo = window.history.tates?.nopi !== null || window.history.states?.nopi !== undefined ? parseInt(window.history.tates.nopi) : 0;
                const nopia = setTimeout(() => {
                    window.scrollTo(0,nnoo);
                  
                }, 1); 
            
          
        
            return ()=>{window.history.states = null;
               
                clearTimeout(nopia);
            };
        };
        }else{
            setarum(window.history.states?.molan == undefined ? "allaround" : window.history.states?.molan);
            setsingle(window.history.states?.page == undefined ? 1 : window.history.states?.page);
        const nnoo = window.history.states?.nopi !== null || window.history.states?.nopi !== undefined ? parseInt(window.history.states?.nopi) : 0;
        
        
        const snopi = setTimeout(() => {
            window.scrollTo(0,nnoo);
           
        }, 1); 
      
        return ()=>{
            window.history.states = null;
            
            clearTimeout(snopi);
           };
     };
    },[]);


    const fnax = async (arum, single, jp)=>{
        const {data} = await axios.get(`/api/pagiza?goal=${arum}&single=${single}&sery=${jp}`);          
       
        return data;
    };

    const {isPending, data : last} = useQuery({queryKey:['kast',arum,single,jp], queryFn: ()=>fnax(arum,single,jp), 
        placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30});

   
    const addnumber=()=>{
        setaddnum(addnum+1);
        setsingle(addnum*10+1);
    };

    const minusnumber=()=>{
        setaddnum(addnum-1);
        setsingle((addnum-1)*10);
    };

    const yidong=(cons)=>{
        window.history.tatat = {adc :true, bdc : false};
        setsingle(cons);
       
        const kogaki = document.getElementById("herija");
        kogaki.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };

    const downi=(e)=>{
      
        if(e.target.id == "one"){
            document.getElementById('two').classList.remove("hwan");
            document.getElementById('three').classList.remove("hwan");
            setarum("allaround");
            setsingle(1);
            document.getElementById('one').classList.add("hwan");
        }else if(e.target.id == "two"){
            document.getElementById('one').classList.remove("hwan");
            document.getElementById('three').classList.remove("hwan");
            setarum("soonend");
            setsingle(1);
            document.getElementById('two').classList.add("hwan");
        }else if(e.target.id == "three"){
            document.getElementById('one').classList.remove("hwan");
            document.getElementById('two').classList.remove("hwan");
            setarum("soongo"); 
            setsingle(1);
            document.getElementById('three').classList.add("hwan");
        }
    };

    return (
        <div className='liba'>
            <div className='heri' id='herija'>
            <div>
            <span id="one" onClick={downi} className="hwan dedan">전체</span>
            <span id="two" onClick={downi} className="dedan">마감임박</span>
            <span id="three" onClick={downi} className="dedan">진행예정</span></div></div>
            <div>
                <table>
                    <tr className='sack1'>
                    <td>{colls}</td>
                    <td className='ontong'>주최사</td>
                    <td>기간</td>
                    <td>마감</td>
                    <td>조회수</td>
                    </tr>                                                   
                {last?.yoso.map((cons,i)=>{
                    const kdk = `/ajo/${cons.id}`;  
                    const upornot = new Date(cons.line);
                    const todaz = new Date();
                    const limitHours = 24; 
                    const durationLimit = limitHours * 60 * 60 * 1000;
                    const isNew = (todaz >= upornot) && ((todaz - upornot) <= durationLimit);     
                 
                    return(
                        <tr className={cons.enroll == 1 ? 'kwang' : 'nokw'}>
                            <td><Link to={kdk} className='ouno' state={cons} onClick={()=>{window.history.pushState({page : single, molan : arum, nopi : window.scrollY, dpo: jp},null,null); 
                        window.history.states = {page : single, molan : arum, nopi : window.scrollY, dpo : jp, pasc:locap.pathname};
                        window.history.tates = {page : single, molan : arum, nopi : window.scrollY, dpo : jp, pasc:locap.pathname};}}>{cons.title}{isNew ? <span className='nowpyo'><span className='nowjum'>·</span>now</span> : ""}</Link></td>
                            <td><div className='fiona'>{cons.holder}</div> </td>
                            <td>{dayjs(cons.start).format('YY-MM-DD')} ~ {dayjs(cons.end).format('YY-MM-DD')}</td>
                            <td>{dayjs(cons.end).startOf('day').diff(dayjs().startOf('day'), 'day') < 0 ? <span className='zhongliao'>마감</span> : dayjs(cons.start).startOf('day').diff(dayjs().startOf('day'), 'day') > 0 ? <span className='kaishi'>진행예정</span> : dayjs(cons.end).startOf('day').diff(dayjs().startOf('day'), 'day') <= 7 ? <span className='madono'>D-{dayjs(cons.end).startOf('day').diff(dayjs().startOf('day'), 'day')}</span>  : `D-${dayjs(cons.end).startOf('day').diff(dayjs().startOf('day'), 'day')}`}</td>
                            <td>{cons.hit}</td></tr>
                    );
                })}
                </table>
            </div>
            <div className='cliper'>
                {addnum >1 && <button onClick={minusnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssleft.png'} className='yulll'/></button>}
                {last?.zonche /100 >= addnum ? Array.from({length : 10},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
                    return(<button onClick={()=>{yidong(cons);}} className="aisu">{cons}</button> );}) : Array.from({length : Math.ceil((last?.zonche%100)/10)},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
                       
                        return(<button onClick={()=>{yidong(cons);}} className={`aisu ${single == cons ? "yahii" : ""}`}>{cons}</button> );})}
                {last?.zonche > addnum*100 && <button onClick={addnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssright.png'} className='yurrr'/></button>}
            </div>
        </div>
    );
};

export default Activ;